import React from "react";
import { Typography } from "@mui/material";
import "./profile.css";
import CustomTimeline, {
  CustomTimelineSeparator,
} from "../Timeline/CostumTimeline";
import resumeData from "../../utils/resumeData";
import TouchAppOutlinedIcon from "@mui/icons-material/TouchAppOutlined";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineContent from "@mui/lab/TimelineContent";
import GetAppIcon from "@mui/icons-material/GetApp";

const CustomTimelineItem = ({ title, text, link }) => (
  <TimelineItem>
    <CustomTimelineSeparator />
    <TimelineContent className="timeline_content">
      {link ? (
        <Typography className="timelineItem_text">
          <span>{title}: </span>
          <a href={link} target="__blank">
            {text}
          </a>
        </Typography>
      ) : (
        <Typography className="timelineItem_text">
          <span>{title}: </span>
          {text}
        </Typography>
      )}
    </TimelineContent>
  </TimelineItem>
);

const Profile = () => {
  return (
    <div className="profile container-shadow">
      <div className="profile_name">
        <Typography className="name">{resumeData.name}</Typography>
        <Typography className="title">{resumeData.title}</Typography>
      </div>
      <figure className="profile-image">
        <img src={require("../../assets/images/2c.png")} alt="" />
      </figure>

      <div className="profile-information">
        <CustomTimeline icon={<TouchAppOutlinedIcon fontSize="large"/>}>
          <CustomTimelineItem title="Email" text={resumeData.email}  />

          {Object.keys(resumeData.socials).map((key) => (
            <CustomTimelineItem
              title={key}
              text={resumeData.socials[key].text}
              link={resumeData.socials[key].link}
            />
          ))}
        </CustomTimeline>
        <div className="button_container">
          <a href={resumeData.resume} className="resume-btn"><span className="btn_text">Download CV</span><GetAppIcon /></a>
          </div>
      </div>
    </div>
  );
};

export default Profile;
